import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('@/views/Test.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/admin',
    name: 'AdminLayout',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: { requiresAuth: true, roles: ['ADMIN'] },
    children: [
      {
        path: '',
        redirect: '/admin/dashboard'
      },
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: () => import('@/views/admin/Dashboard.vue')
      },
      {
        path: 'users',
        name: 'AdminUsers',
        component: () => import('@/views/admin/UserManagement.vue')
      },
      {
        path: 'categories',
        name: 'AdminCategories',
        component: () => import('@/views/admin/CategoryManagement.vue')
      },
      {
        path: 'products',
        name: 'AdminProducts',
        component: () => import('@/views/admin/ProductManagement.vue')
      },
      {
        path: 'orders',
        name: 'AdminOrders',
        component: () => import('@/views/admin/OrderManagement.vue')
      },
      {
        path: 'banners',
        name: 'AdminBanners',
        component: () => import('@/views/banner/BannerManagement.vue')
      },
      {
        path: 'recommended',
        name: 'AdminRecommended',
        component: () => import('@/views/admin/RecommendedProductManagement.vue')
      },
      {
        path: 'profile',
        name: 'AdminProfile',
        component: () => import('@/views/Profile.vue')
      }
    ]
  },
  {
    path: '/supplier',
    name: 'SupplierLayout',
    component: () => import('@/layouts/SupplierLayout.vue'),
    meta: { requiresAuth: true, roles: ['SUPPLIER'] },
    children: [
      {
        path: '',
        redirect: '/supplier/dashboard'
      },
          {
            path: 'dashboard',
            name: 'SupplierDashboard',
            component: () => import('@/views/supplier/Dashboard.vue')
          },
          {
            path: 'orders',
            name: 'SupplierOrders',
            component: () => import('@/views/supplier/OrderManagement.vue')
          },
      {
        path: 'profile',
        name: 'SupplierProfile',
        component: () => import('@/views/Profile.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = store.getters.token
  const userRole = store.getters.userRole

  // 需要认证的路由
  if (to.meta.requiresAuth) {
    if (!token) {
      next('/login')
      return
    }

    // 角色权限检查
    if (to.meta.roles && !to.meta.roles.includes(userRole)) {
      next('/login')
      return
    }
  }

  // 已登录用户访问登录页，重定向到对应的首页
  if (to.path === '/login' && token) {
    if (userRole === 'ADMIN') {
      next('/admin')
    } else if (userRole === 'SUPPLIER') {
      next('/supplier')
    } else {
      next()
    }
    return
  }

  next()
})

export default router
